import { Form } from 'antd';
import { Layout } from 'components/Layout/Layout';
import { useCreateInventoryMeterReadingGroup } from 'hooks/api/reading-groups/useCreate';
import { VFC } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { GroupDetailCard } from '../components/GroupDetailCard';
import { CreateReadingGroupPage as messages } from '../messages';
import { GroupDetailsForm } from '../types';
import { GroupDetailFooter } from '../components/Footer';

export const CreateReadingGroupPage: VFC = () => {
  const [form] = Form.useForm<GroupDetailsForm>();
  const navigate = useNavigate();
  const intl = useIntl();

  const { mutate: createGroup, isLoading } = useCreateInventoryMeterReadingGroup({
    onSuccess: createdGroup => {
      if (createdGroup?.id) {
        navigate(`/reading-groups/${createdGroup.id}`);
      }
    },
  });

  const handleFinish = (values: GroupDetailsForm) => {
    createGroup(values);
  };

  return (
    <Layout footerContent={<GroupDetailFooter />} headerContent={intl.formatMessage(messages.header)}>
      <GroupDetailCard
        groupForm={form}
        isLoading={isLoading}
        title={intl.formatMessage(messages.header)}
        onFinish={handleFinish}
      />
    </Layout>
  );
};
